import type { Auth0Config } from '@omnipresentgroup/auth';

type Environment = {
  production?: boolean;
  environment?: string;
  auth0Config: Auth0Config;
  sentry: { SENTRY_DSN?: string };
  endpoints: {
    FLEXIBLE_FORMS_API?: string;
    OMNIPLATFORM_API?: string;
    CONTRACTORS_API?: string;
    DOCUMENT_STORAGE_BUCKET?: string;
    TIMESHEETS_API?: string;
    FINANCIAL_DOCS_API?: string;
    PAYROLL_API?: string;
    COMPENSATION_API?: string;
    EMPLOYMENT_TIME_API?: string;
    INTEGRATIONS_API?: string;
    XERO_INTEGRATIONS_API?: string;
    CUTOFF_REPORTS_API?: string;
    CLIENT_MANAGEMENT_API?: string;
  };
  apps: {
    OMNIPLATFORM?: string;
    MANAGER?: string;
  };
  cypressAuth0Users: {
    auth0_employee_user?: string;
    auth0_manager_user?: string;
    auth0_regular_manager_user?: string;
    auth0_password?: string;
  };
  features: {
    isFormBuilderEnabled: boolean;
    isFormBuilderPublishEnabled: boolean;
  };
  launchDarkly: {
    CLIENT_SIDE_ID?: string;
  };
  mixpanel: { MIXPANEL_APP_ID?: string };
  intercomAppId?: string;
  omnipresentTenantId?: string;
};

export const environment: Environment = {
  production: process.env.PRODUCTION === 'true',
  environment: process.env.ENVIRONMENT,
  auth0Config: {
    AUTH0_DOMAIN: process.env.AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID,
    AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE,
    AUTH0_BASE_URL: process.env.AUTH0_BASE_URL,
  },
  endpoints: {
    FLEXIBLE_FORMS_API: process.env.FLEXIBLE_FORMS_API,
    OMNIPLATFORM_API: process.env.OMNIPLATFORM_API,
    CONTRACTORS_API: process.env.CONTRACTORS_API,
    DOCUMENT_STORAGE_BUCKET: process.env.DOCUMENT_STORAGE_BUCKET,
    TIMESHEETS_API: process.env.TIMESHEETS_API,
    FINANCIAL_DOCS_API: process.env.FINANCIAL_DOCS_API,
    PAYROLL_API: process.env.PAYROLL_API,
    COMPENSATION_API: process.env.COMPENSATION_API,
    EMPLOYMENT_TIME_API: process.env.EMPLOYMENT_TIME_API,
    INTEGRATIONS_API: process.env.INTEGRATIONS_API,
    XERO_INTEGRATIONS_API: process.env.XERO_INTEGRATIONS_API,
    CUTOFF_REPORTS_API: process.env.CUTOFF_REPORTS_API,
    CLIENT_MANAGEMENT_API: process.env.CLIENT_MANAGEMENT_API,
  },
  apps: {
    OMNIPLATFORM: process.env.OMNIPLATFORM_APP,
    MANAGER: process.env.MANAGER_APP,
  },
  cypressAuth0Users: {
    auth0_employee_user: process.env.AUTH0_EMPLOYEE_USER,
    auth0_manager_user: process.env.AUTH0_MANAGER_USER,
    auth0_regular_manager_user: process.env.AUTH0_REGULAR_MANAGER_USER,
    auth0_password: process.env.AUTH0_PASSWORD,
  },
  features: {
    isFormBuilderEnabled: process.env.IS_FORMBUILDER_ENABLED === 'true',
    isFormBuilderPublishEnabled:
      process.env.IS_FORMBUILDER_PUBLISH_ENABLED === 'true',
  },
  launchDarkly: {
    CLIENT_SIDE_ID: process.env.LAUNCHDARKLY_CLIENT_SIDE_ID,
  },
  mixpanel: { MIXPANEL_APP_ID: process.env.MIXPANEL_APP_ID },
  sentry: { SENTRY_DSN: process.env.SENTRY_DSN },
  intercomAppId: process.env.INTERCOM_APP_ID,
  omnipresentTenantId: process.env.OMNIPRESENT_TENANT_ID,
};
